import { render, staticRenderFns } from "./HomeApplicant.vue?vue&type=template&id=153b44dc&"
import script from "./HomeApplicant.vue?vue&type=script&lang=js&"
export * from "./HomeApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports